// extracted by mini-css-extract-plugin
export var button = "_jz-0";
export var donut = "_jz-1";
export var donutFill = "_jz-3";
export var donutTrack = "_jz-2";